export const API_BASE_URL = 'https://api.mfs.maed.farm'
